/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    ico?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    locale?: UserDtoLocaleEnum;
}


/**
 * @export
 */
export const UserDtoLocaleEnum = {
    Sk: 'SK',
    En: 'EN',
    Pl: 'PL',
    Hu: 'HU',
    De: 'DE'
} as const;
export type UserDtoLocaleEnum = typeof UserDtoLocaleEnum[keyof typeof UserDtoLocaleEnum];


/**
 * Check if a given object implements the UserDto interface.
 */
export function instanceOfUserDto(value: object): value is UserDto {
    return true;
}

export function UserDtoFromJSON(json: any): UserDto {
    return UserDtoFromJSONTyped(json, false);
}

export function UserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'ico': json['ico'] == null ? undefined : json['ico'],
        'email': json['email'] == null ? undefined : json['email'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'locale': json['locale'] == null ? undefined : json['locale'],
    };
}

export function UserDtoToJSON(json: any): UserDto {
    return UserDtoToJSONTyped(json, false);
}

export function UserDtoToJSONTyped(value?: UserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'ico': value['ico'],
        'email': value['email'],
        'companyName': value['companyName'],
        'locale': value['locale'],
    };
}

